<template>
  <div class="uk-card uk-card-default uk-card-body uk-card-hover">
    <div
      class="uk-card-header uk-padding uk-padding-small uk-padding-remove-left"
    >
      <div class="uk-card-badge uk-label" v-html="label"></div>
      <div class="uk-grid-small uk-flex-middle" uk-grid>
        <div class="uk-width-expand uk-margin-small-top">
          <h3 class="uk-card-title uk-margin-remove-bottom uk-text-bold">
            <a :href="link" target="_blank" v-html="name"></a>
          </h3>
          <p
            class="uk-text-meta uk-text-bold uk-margin-remove-top"
            v-html="stack"
          ></p>
        </div>
      </div>
    </div>
    <div
      class="uk-card uk-card-body uk-padding-small uk-padding-remove-left uk-padding-remove-left uk-padding-remove-bottom"
    >
      <p v-html="description"></p>
      <ul class="uk-list uk-list-bullet">
        <li v-for="item in items" v-bind:key="item.id">
          <p v-html="item.title"></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectCards",
  props: {
    name: String,
    label: String,
    stack: String,
    link: String,
    description: String,
    items: Array,
  },
};
// , 'label', 'stack', 'description','items']
</script>

<style scoped>
p,
h3 {
  font-family: "overpass", sans-serif;
  font-weight: 600;
  font-style: normal;
}
</style>
